/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ReactNode } from 'react';
import Heading from '@atlaskit/heading/heading';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import { SideNavHeader, SideNavBody } from '@atlaskit/navigation-system/layout/side-nav';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { BackButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-back-button/src/ui/back-button/index.tsx';
import { AsyncPageSwitcher } from '../../common/ui/page-switcher/index.tsx';
import type { PageName } from '../../common/ui/page-switcher/types.tsx';

const heading = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Jira admin settings',
	description: 'Heading for the global jira settings pages',
});

type Props = {
	children: ReactNode;
	currentPageName: PageName;
	testId?: string;
};

export const SidebarContent = ({
	children,
	currentPageName,
	testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content',
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			<SideNavHeader>
				<Stack space="space.200" xcss={headingStyles}>
					<Inline
						alignBlock="center"
						grow="hug"
						space="space.100"
						// eslint-disable-next-line jira/integration/test-id-by-folder-structure
						testId="navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
					>
						<BackButton />
						<Heading size="small" as="h2">
							{formatMessage(heading)}
						</Heading>
					</Inline>

					<AsyncPageSwitcher currentPageName={currentPageName} />
				</Stack>
			</SideNavHeader>
			<SideNavBody testId={testId}>
				<MenuList>{children}</MenuList>
			</SideNavBody>
		</>
	);
};

const headingStyles = xcss({
	// 4px of left padding is added to align the back icon with the side nav toggle button
	paddingInlineStart: 'space.050',
});
